<template>
  <div>
    <Layout :pagetitle="$t('Brand')">
      <form autocomplete="off" @submit.prevent="saveBrand">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Brand') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="6" v-if="permission.rewardProfile">
              <label>{{ $t('Reward Profile') }}</label>
              <rewardProfileSelector :modelValue="idRewardProfile" @onChange="selectProfile" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'Site URL' }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="site" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'Api Key' }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="settings.apiKey" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'App Id' }}</label>
              <b-form-input :trim="true" autocomplete="off" type="number" v-model="settings.siteMetadata.appId" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'App Token' }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="settings.siteMetadata.appToken" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'URL Advertising' }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="settings.urlAdvertising" />
            </b-col>

            <b-col class="mt-2" md="6">
              <label>{{ 'Zerar comissão em caso de GGR negativo' }}</label>
              <b-form-select
                v-model="settings.zeroRewardOnNegativeGgr"
                :options="[
                  { value: true, text: $t('Sim') },
                  { value: false, text: $t('Não') }
                ]"
              />
            </b-col>
            <b-col class="mt-2" md="6">
              <label>{{ $t('Carry negative GGR balance') }}</label>
              <select v-model="settings.carryNegativeGgr" class="form-control">
                <option :value="true">{{ $t('Yes') }}</option>
                <option :value="false">{{ $t('No') }}</option>
              </select>
              <b-alert class="mt-2 mb-0" show variant="warning" v-if="settings.carryNegativeGgr">
                {{ $t('GGR closing completed month warning') }}
              </b-alert>
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector.vue';

export default {
  components: { Layout, rewardProfileSelector },
  data() {
    return {
      name: '',
      idRewardProfile: null,
      site: '',
      settings: {
        apiKey: '',
        zeroRewardOnNegativeGgr: false,
        siteMetadata: {
          appId: null,
          appToken: ''
        },
        urlAdvertising: '',
        carryNegativeGgr: false
      },
      permission: {
        rewardProfile: false
      }
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getBrand();
    }
    this.permission.rewardProfile = this.$utils.checkRole('rewardProfile');
  },
  methods: {
    saveBrand() {
      if (this.$route.params?.id) {
        this.updateBrand();
      }
    },
    getBrand() {
      const brandId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/brand/${brandId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let brand = res.data;

          this.name = brand.name;
          this.idRewardProfile = brand.id_reward_profile;
          this.site = brand.site;
          this.settings = {
            ...this.settings,
            ...(brand?.settings || {})
          };
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    updateBrand() {
      if (!this.validateBrand()) return;
      let brandId = this.$route.params.id;
      let brand = {
        name: this.name,
        idRewardProfile: this.idRewardProfile,
        site: this.site,
        settings: this.settings
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/brand/${brandId}`, brand)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'brandList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update brand error')
          });
        });
    },
    selectProfile(reward_profile_id) {
      this.idRewardProfile = reward_profile_id;
    },
    validateBrand() {
      if (!this.name) {
        this.$customAlert({
          msg: this.$t('Invalid name'),
          type: 'error'
        });
        return false;
      }

      if (this.permission.rewardProfile && !this.idRewardProfile) {
        this.$customAlert({
          msg: this.$t('Select a reward profile'),
          type: 'error'
        });
        return false;
      }

      return true;
    }
  }
};
</script>

<style></style>
